// © Microsoft Corporation. All rights reserved.

import { enums } from "./enums";

export function hasThemeBase(theme, targetTheme) {
    return theme && theme.startsWith(targetTheme.name);
}

export function isThemeEqual(theme, targetTheme) {
    return theme == targetTheme.name;
}

export function isComponentDisabled(theme, component) {
    let disabledComponents = [];
    for (const key in enums.theme) {
        if (enums.theme[key].name === theme) {
            disabledComponents = enums.theme[key].disabledComponents;
            break;
        }
    }
    return disabledComponents.includes(component);
}

export function isComponentInModal(theme, component) {
    let modalComponents = [];
    for (const key in enums.theme) {
        if (enums.theme[key].name === theme) {
            modalComponents = enums.theme[key].modalComponents;
            break;
        }
    }
    return modalComponents && modalComponents.includes(component);
}